import styles from "../../styles/components/FilePreview.module.scss";
import warning from "../../assets/images/warning.svg";

import { downloadFile } from "../../functions/actions/documents";

import MsgReader from 'msgreader';
import parse from 'emailjs-mime-parser'

import React, { useEffect, useState } from 'react'
import { Button } from "../ui/button";

import { Document, Page, pdfjs } from 'react-pdf'
import "react-pdf/dist/esm/Page/TextLayer.css";
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import axios from "src/axios/axios";
import { Loader2 } from "lucide-react";
import FilePreview, { Extension } from "./file-previewer";
import { useTranslation } from "react-i18next";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;


type Props = {
    docid:number,
    filename: string
}

const Preview : React.FC<Props> = ({docid}) => {
    const { t } = useTranslation()
    const [full_file, setfull_file] = useState();
    const [isLoading, setisLoading] = useState(false);

    useEffect(()=>{
        getDocURL()
    }, [docid])

    const getDocURL = async () => {
        setisLoading(true)
        try { 
            let {data:d} = await axios.get(`documents/get?docid=${docid}`)
            if(d.errorcode === 0){
                setfull_file(d.object);
            }
            else {
                return;
            }
        } catch(e) { console.log(e) }
        finally { setisLoading(false) }
    }

  return (
    <>
        {isLoading && <p className="absolute z-50 flex items-center gap-2 px-3 py-1 -translate-x-1/2 border rounded-full left-1/2 w-fit top-4 bg-white/50 backdrop-blur-sm"><Loader2 className="w-4 h-4 animate-spin"/> {t('Even geduld')}...</p>}
        {isLoading && <div className="absolute top-0 left-0 bottom-0 right-0 bg-white/80 backdrop-blur-lg z-[49]"></div>}

        {/* @ts-ignore */}
        {(full_file && 'file' in full_file) && <FilePreview base64={full_file.file} extension={full_file.filename.split('.')[full_file.filename.split('.').length-1].toLowerCase()}/>}
    </>
  )
}

export default Preview

export interface Message {
    attachments: Attachment[];
    recipients:  Recipient[];
    senderName:  string;
    senderEmail: string;
    subject:     string;
    body:        string;
    headers:     string;
}

export interface Attachment {
    extension:     string;
    dataId:        number;
    contentLength: number;
    fileName:      string;
    fileNameShort: string;
    name:          string;
    pidContentId?: string;
}

export interface Recipient {
    name:  string;
    email: string;
}

export interface MessageHeaders {
    received:                  string;
    results:                   string;
    type:                      string;
    encoding:                  string;
    from:                      string;
    to:                        string;
    cc:                        string;
    subject:                   string;
    topic:                     string;
    index:                     string;
    date:                      string;
    language:                  string;
    attach:                    string;
    scl:                       string;
    version:                   string;
    messagedirectionality:     string;
    authsource:                string;
    authas:                    string;
    authmechanism:             string;
    publictraffictype:         string;
    path:                      string;
    expirationstarttime:       string;
    expirationstarttimereason: string;
    expirationinterval:        string;
    expirationintervalreason:  string;
    id:                        string;
    traffictypediagnostic:     string;
    oobclassifiers:            string;
    antispam:                  string;
    originalarrivaltime:       string;
    fromentityheader:          string;
    mailboxtype:               string;
    userprincipalname:         string;
    crosstenantheadersstamped: string;
    endtoendlatency:           string;
    bccfoldering:              string;
}